import { ValidationEnum } from 'utils/enums/validationEnums';
import { ValidationObj } from '../../../types/interface';
import { patterns } from 'utils/patterns';
import { group } from 'console';

export const commonValidations: { [key: string]: ValidationObj[] } = {
  email: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.common.email.message_1',
      message: 'Please enter your email.'
    },
    {
      type: ValidationEnum.PATTERN,
      expression: patterns.email,
      key: 'validation.common.email.message_2',
      message: 'Please enter a valid email address.'
    }
  ],
  admin_level_ids: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.user.admin_level',
      message: 'Please select admin level'
    }
  ],
  password: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.common.password.message_1',
      message: 'Please enter your password.'
    },
    {
      type: ValidationEnum.MINLENGTH,
      value: 8,
      key: 'validation.common.password.message_2',
      message: 'Password must be at least 8 characters long.'
    },
    {
      type: ValidationEnum.PATTERN,
      expression:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[+_*&^%$#@!\-.,])[a-zA-Z\d+_*&^%$#@!\-.,]{8,}$/,
      key: 'validation.common.password.message_2',
      message:
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.'
    }
  ],
  firstName: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.user.first_name',
      message: 'Please enter first name'
    }
  ],
  lastName: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.user.last_name',
      message: 'please enter last name'
    }
  ],
  role_id: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.user.role',
      message: 'please enter role'
    }
  ],
  type: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.user.type_of_employee',
      message: 'please select type of employee'
    }
  ],
  productName: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.product.product_name',
      message: 'Please enter product name'
    }
  ],
  refundable: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.product.refundable',
      message: 'Please select refundable'
    }
  ],
  productChangeValue: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.product.product_change_value',
      message: 'Please select application type option request'
    }
  ],
  productNameGerman: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.product.product_name_german',
      message: 'Please enter product name in German'
    }
  ],
  eventName: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.event.event_name',
      message: 'Please enter event name'
    }
  ],
  roleName: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.role.role_name',
      message: 'Please enter role name'
    }
  ],
  moduleArray: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.role.module_array',
      message: 'please enter module '
    }
  ],
  roleNameEn: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.role.role_name_en',
      message: 'Please enter role name english'
    }
  ],
  roleNameDe: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.role.role_name_de',
      message: 'Please enter role name german'
    }
  ],
  optionType: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.application_type_option.option_type',
      message: 'Please enter option type'
    }
  ],
  optionTypeGerman: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.application_type_option.option_type_german',
      message: 'Please enter option type in German'
    }
  ],
  popupGetId: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.application_type_option.product_change_value',
      message: 'Please enter popup get id'
    }
  ],
  net_income: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.basic_data_with.net_income',
      message: 'Please enter net income'
    }
  ],
  refund_percentage: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.basic_data_with.refund_percentage.message_1',
      message: 'Please enter refund percentage'
    },
    {
      type: ValidationEnum.PATTERN,
      expression: patterns.maxPercentage,
      key: 'validation.basic_data_with.refund_percentage.message_2',
      message: 'Please enter a valid percentage'
    }
  ],
  support_provided: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.basic_data_with.total_support',
      message: 'Please enter total support'
    }
  ],
  configuration_threshold_invoice: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.basic_data_without.configuration_threshold_invoice',
      message: 'Please enter configuration threshold invoice'
    }
  ],
  host: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.host',
      message: 'Please enter host name'
    }
  ],
  port: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.port',
      message: 'Please enter port number'
    }
  ],
  user: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.user',
      message: 'Please enter user name'
    }
  ],
  pass: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.password',
      message: 'Please enter password'
    }
  ],
  to: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.to',
      message: 'Please enter recipient email'
    }
  ],
  from: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.email_test.from',
      message: 'Please enter sender email'
    }
  ],
  applicationType: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.product.application_type',
      message: 'Please select application type'
    }
  ],
  level_name: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.level.level_name',
      message: 'Please enter level name'
    }
  ],
  level_order: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.level.level_order',
      message: 'Please enter level order'
    },
    {
      type: ValidationEnum.PATTERN,
      expression: patterns.number,
      key: 'validation.level.level_order_valid',
      message: 'Please enter a valid number'
    }
  ],
  level_name_de: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.level.level_name_de',
      message: 'Please enter level name in German'
    }
  ],
  state_id: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.state.state_id',
      message: 'Please select state'
    }
  ],
  group_management_level_name: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.group_management.group_management_level_name',
      message: 'Please enter group management level name'
    }
  ],
  group_management_level_name_de: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.group_management.group_management_level_name_de',
      message: 'Please enter group management level name in German'
    }
  ],
  admin_level: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.group_management.admin_level',
      message: 'Please enter admin level'
    }
  ],
  level_order_valid: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.group_management.level_order_valid',
      message: 'Please select federal state'
    }
  ],
  state_admin_level_group: [
    {
      type: ValidationEnum.REQUIRED,
      key: 'validation.group_management.state_admin_level_group',
      message: 'Please select admin level and federal state group'
    }
  ]
};
